import React, { useState, useMemo, useEffect } from 'react'
import { TableColumn } from 'tea-component'
import { formatExeclNormalPercent, formatExeclNum, formatNum, formatPercentNum, getChartDateFormatString, getWeekDay } from '@/pages/dashboard/utils/utils'
import { useLocal, useWeekDay } from '@/pages/dashboard/utils/customHook';
import { connect, getLocale, useIntl } from 'umi';
import { momentFormat } from '@/pages/dashboard/utils/_config/filtersTimeFormat';
import ChurnChartCo from './ChurnChartCo';
import { getEchartTooltipText } from '@/pages/dashboard/components/EchartsBubble';

const ChurnLevelDisContext = (props:any) => {
  const locale = getLocale();
  const { formatMessage } = useIntl(); // 中英切换方法
  const { getWeekDay } = useWeekDay();
  const isEN = locale == 'en-US';

  const defaultConfig = {
    timeType : 'Day',
    configTabList : [
      {
        cnText : '新增流失用户',
        enText : 'New Churn Users',
        value : 'newChurn'
      },{
        cnText : '累计流失',
        enText : 'Accumulated',
        value : 'accumulated'
      }
    ],
    enTitle : 'Churn level Distribution',
    cnTitle : '流失用户等级构成',
    hideConfig : {
      eyes : true
    },
    tab : 'newChurn',
    apiKey : {
      accChart : {
        key : 'name',
        value : 'acc_churn_users'
      },
      newChart : {
        key : 'name',
        value : 'new_churn_users'
      }
    },
    cnEChartTilte : '等级',
    enEChartTilte : 'Level',
    cnEChartMetricsName : '流失用户',
    enEChartMetricsName : 'Churn Users',
    defaultActive : 0
  }

  const {
    timeType = defaultConfig.timeType,
    enTitle = defaultConfig.enTitle, 
    cnTitle = defaultConfig.cnTitle, 
    hideConfig = defaultConfig.hideConfig, 
    configTabList = defaultConfig.configTabList, 
    tab = defaultConfig.tab,
    apiKey = defaultConfig.apiKey,
    cnEChartTilte = defaultConfig.cnEChartTilte,
    enEChartTilte = defaultConfig.enEChartTilte,
    cnEChartMetricsName = defaultConfig.cnEChartMetricsName, 
    enEChartMetricsName = defaultConfig.enEChartMetricsName, 
    defaultActive = defaultConfig.defaultActive
  } = props?.config;
  const metricsData= props?.data?.data || {};
  const hasMonth = timeType === 'Month';
  
  const { data, loading: isLoading, errorMsg: isError } = metricsData || {};
  const isNoData = data?.length <= 0;

  const [tabName, setTabName] = useState(tab);
  const [accChartData, setAccChartData] = useState([])
  const [newChartData, setNewChartData] = useState([])

  const title = isEN ? enTitle : cnTitle;
  const EChartTitle = isEN ? enEChartTilte : cnEChartTilte;
  const EChartMetricsName = isEN ? enEChartMetricsName : cnEChartMetricsName;

  const CHURN_LEVEL_OPTIONS: any = {
    1: formatMessage({ id: 'engagement_churn_Inactivity_level_1' }),
    2: formatMessage({ id: 'engagement_churn_Inactivity_level_2' }),
    3: formatMessage({ id: 'engagement_churn_Inactivity_level_3' }),
    4: formatMessage({ id: 'engagement_churn_Churned' }),
    5: formatMessage({ id: 'engagement_churn_Stale' }),
    255: "All"
  }

  const tabList = configTabList.map((v : any) => {
    return {
      text : isEN ? v.enText : v.cnText,
      value : v.value
    }
  });

  useEffect(()=>{
    const dataList: Array<listItem> = data || [];
    const newDataRes: any[] = [];
    const accDataRes: any[] = [];

    let cnt = dataList?.filter((item)=>{return item.date === dataList[0]?.date}).length

    for(let i = 0; i < dataList.length; i = i + cnt) {
      const kvList = []
      const kvList2 = []
      for(let j = 0; j < cnt; j++) {
        kvList.push({
          key: CHURN_LEVEL_OPTIONS[dataList[i+j]?.[apiKey.newChart.key] || ''],
          value: dataList[i+j]?.metrics?.[apiKey.newChart.value].value || ''
        })
        kvList2.push({
          key: CHURN_LEVEL_OPTIONS[dataList[i+j]?.[apiKey.accChart.key] || ''],
          value: dataList[i+j]?.metrics?.[apiKey.accChart.value].value || ''
        })
      }
      newDataRes.push({
        date: getChartDateFormatString(timeType, dataList[i].date, true) || "",
        kv_list: kvList
      })

      accDataRes.push({
        date: getChartDateFormatString(timeType, dataList[i].date, true) || "",
        kv_list: kvList2
      })
    }

    setAccChartData(accDataRes)
    setNewChartData(newDataRes)

}, [data, locale])

function formatterFunc(list: { seriesName: string; value: string | number; color: string; }[]) {
  const data: any[] = [];
  list.forEach(({ seriesName, value, color }) => {
    if (value === '' || value == 0) return;

    data.push({
      name: seriesName,
      metricsNum: formatNum(value, false, true),
      color,
    });
  });

  if (data?.length <= 0) return '<div></div>';

  return getEchartTooltipText({
    title: EChartTitle || '',
    metricsName: EChartMetricsName || '',
    data,
  });
}

const options = useMemo(() => {
    const ChurnLevelDisturb = tabName === "newChurn" ? newChartData : accChartData;

    const heads = ChurnLevelDisturb[0]?.kv_list?.map((item)=>{return item.key}) || []

    // 表头数据
    let rightTHead: Array<{}> = [
      {
        key: 'date',
        header: formatMessage({ id: 'engagement_churn_Date' }),
        align: 'left',
        fixed: 'left',
        width: 160,
        render: (cvm) => {
          const weekDay = getWeekDay(cvm?.date);
          const isSunOrSat =
            weekDay === 'Sun' ||
            weekDay === 'Sat' ||
            weekDay === '周日' ||
            weekDay === '周六';
          return (
            <>
              <span className="table-text">{cvm?.date}</span>
              {timeType !== 'Month' && (
                <span className={isSunOrSat ? 'text-week-b' : 'text-week'}>
                  {weekDay}
                </span>
              )}
            </>
          );
        },
      },
      ...heads.map((ele) => ({
        key: ele,
        header: ele,
        align:'right',
        width: ele === "Churned" || ele === "Stale" ? 130 : 160,
      })),
    ];

    // 表格数据
    let rightTData: Array<{}> = [];
    {
      ChurnLevelDisturb?.forEach((ele) => {
        let date = hasMonth ? momentFormat(ele.date, 'YYYY-MM') : ele.date;
        let kvs = ele.kv_list || [];
        let len = kvs.length,
          i,
          val;
        let temp = { date };

        heads.forEach((k) => {
          val = '';
          for (i = len; i--; ) {
            if (kvs[i].key === k) {
              val = kvs[i].value;
              break;
            }
          }
          temp[k] = '' + formatNum(val, false, true);
        });

        len && rightTData.push(temp);
      });
    }

    //下载数据
    let rightTDownloadData: Array<{}> = [];
    {
      ChurnLevelDisturb?.forEach((ele) => {
        let date = hasMonth ? momentFormat(ele.date, 'YYYY-MM') : ele.date;
        let kvs = ele.kv_list || [];
        let len = kvs.length,
          i,
          val;
        let temp = { date };

        heads.forEach((k) => {
          val = '';
          for (i = len; i--; ) {
            if (kvs[i].key === k) {
              val = kvs[i].value;
              break;
            }
          }
          temp[k] = formatExeclNum(val);
        });

        len && rightTDownloadData.push(temp);
      });
    }

    // 图表
    const rightChart: {
      name: string;
      stack: string;
      data: any[];
    }[] = [];

    heads?.forEach((level) => {
      const data: {
        x: string;
        y: string | number;
      }[] = [];
      ChurnLevelDisturb?.forEach(({date="", kv_list=[]}) => {
        const value = kv_list?.filter((item) => item?.key === level)?.[0]?.value;

        data.push({
          x: date,
          y: Math.round(value) || value,
        });
      });
      rightChart.push({
        name: level,
        stack: 'stack',
        data,
      });
    });

    return {
        chart: rightChart,
        table: {
           option: rightTHead,
            data: rightTData,
            downloadData: rightTDownloadData,
        },
    }

}, [tabName, accChartData, newChartData])

  return (
    <>
        <ChurnChartCo
            options={options} 
            tabName={tabName} 
            setTabName={setTabName} 
            timeType={timeType} 
            tabList={tabList} 
            title={title} 
            isLoading ={isLoading} 
            isError ={isError}  
            isNoData ={isNoData} 
            defaultActive ={defaultActive}
            formatterFunc={formatterFunc}
            hideConfig={hideConfig}
        />
    </>

  );
};
export default ChurnLevelDisContext